import IonIcon from '@reacticons/ionicons'
import React from 'react'

interface ModalCloseProps {
  onClose: () => void
  className?: string
}

/**
 * Primary UI component for user interaction
 */
export const ModalCloseButton: React.FC<ModalCloseProps> = ({ onClose, className }) => {
  const defaultClassName = className || 'md:top-[2px] top-[6px] md:right-[2px] right-[2px]'
  return (
    <>
      {/* <div className="ml-auto cursor-pointer text-textdark relative" onClick={onClose}>
        <div className="w-4 h-4 m-2 rounded-md bg-white absolute z-20"></div>
        <IonIcon name="close-circle" className="!h-[30px] !w-[30px] relative z-30" />
      </div> */}
      <span
        className={`ml-auto ${defaultClassName} cursor-pointer text-textdark relative`}
        onClick={onClose}
        aria-label="Close"
      >
        <div className="w-4 h-4 m-2 rounded-md bg-white absolute z-20"></div>
        <IonIcon name="close-circle" className="!h-[30px] !w-[30px] relative z-30" />
      </span>
    </>
  )
}
